export enum UploadStatus {
    Pending = 'Pending',
    Uploading = 'Uploading',
    Completed = 'Completed',
    Failed = 'Failed',
    Cancelled = 'Cancelled',
}

export interface UploadItem {
    /** Liste / state güncellemeleri için benzersiz kimlik (normalize sonrası aynı fileName olabilir). */
    clientId: string;
    file: File;
    /** API'ye giden normalize edilmiş ad (uzantı öncesi boşluk temizlenmiş). */
    fileName: string;
    /** Kullanıcıya gösterilen orijinal dosya adı (boşluklu hali korunur). */
    rawFileName: string;
    /** Backend'in hesapladığı S3 upload adı; yoksa fileName kullanılır. */
    storedFilename?: string;
    originalFilePath: string;
    totalSize: number;
    bytesSent: number;
    progress: number;
    status: UploadStatus;
    errorMessage: string;
    abortController: AbortController | null;
    currentAttempt: number;
    maxAttempts: number;
    /** CreateFileTransferRequest yanıtı */
    fileTransferRequestId: number | null;
    fileTransferRequestDetailId: number | null;
    fileUploadPath?: string;
}

export type ChunkDescriptor = { index: number; blob: Blob };

export const UPLOAD_CHUNK_SIZE_BYTES = 10 * 1024 * 1024;
export const UPLOAD_CHUNK_CONCURRENCY = 5;
export const UPLOAD_CHUNK_RETRIES = 3;
